import React, { ReactNode } from "react";
import { cardStyles, getRingStyle } from "../styles";

interface CardSlotProps {
  children?: ReactNode;
  isSelected?: boolean;
  isValidDestination?: boolean;
  onClick?: () => void;
}

export const CardSlot: React.FC<CardSlotProps> = ({
  children,
  isSelected = false,
  isValidDestination = false,
  onClick,
}) => {
  const ringStyle = getRingStyle(isSelected, isValidDestination);

  return (
    <div className={`${cardStyles.container} ${ringStyle}`} onClick={onClick}>
      {children || <div className={cardStyles.emptySlot}></div>}
    </div>
  );
};

export default CardSlot;
